// eslint-disable-next-line no-shadow
export enum CommonQueryKeys {
  BENEFIT_MODELS = "benefit-models",
}
